import React from "react";
import { Actionable, Button, SheetContainer } from "@bookingcom/bui-react";
import { useUnifiedPriceTagPriceBreakdownController } from "./useUnifiedPriceTagPriceBreakdown.controller.js";
import useRouteName from "../../../hooks/useRouteName.js";
import styles from "./UnifiedPriceTag.module.css";
export const UnifiedPriceTagPriceBreakdownMobile = ({ priceBreakdownTrigger, priceBreakdownTriggerProps, priceBreakdownContent, priceBreakdownCloseAriaLabel, priceBreakdownOnOpen = () => { }, priceBreakdownOnClose = () => { } }) => {
    const { contentTitle, closeAriaLabel, showPriceBreakdown, setShowPriceBreakdown } = useUnifiedPriceTagPriceBreakdownController();
    const routeName = useRouteName();
    if (!priceBreakdownTrigger) {
        return;
    }
    const handlePriceBreakdownClick = (e) => {
        if (!!priceBreakdownContent) {
            e.stopPropagation();
            if (!showPriceBreakdown) {
                setShowPriceBreakdown(true);
                priceBreakdownOnOpen();
            }
        }
    };
    const priceStrikethroughIconAsButton = (React.createElement(Button, { variant: "tertiary-neutral", size: "medium", ...priceBreakdownTriggerProps, onClick: handlePriceBreakdownClick }, priceBreakdownTrigger));
    return (React.createElement(React.Fragment, null,
        routeName.includes("flightdetails") ? (priceStrikethroughIconAsButton) : !!priceBreakdownContent ? (React.createElement(Actionable, { onClick: handlePriceBreakdownClick, ...priceBreakdownTriggerProps, className: styles.priceBreakdownTriggerMobile, tagName: "span" }, priceBreakdownTrigger)) : (priceBreakdownTrigger),
        showPriceBreakdown && (React.createElement(SheetContainer, { onCloseTrigger: () => {
                setShowPriceBreakdown(false);
                priceBreakdownOnClose();
            }, title: contentTitle, closeAriaLabel: priceBreakdownCloseAriaLabel || closeAriaLabel, active: true, attributes: {
                "data-testid": "upt_price_breakdown_content"
            } }, priceBreakdownContent))));
};
